import type { ReactElement } from 'react';

import { ScrollArea } from 'src/components/ui/scroll-area';
import { cn } from 'src/lib/utils';

type ConfigurationCriteriaProductsRecapListProps = {
  title: string;
  description: string;
  titleClassName?: string;
  listClassName?: string;
  skus: string[];
};

export function ConfigurationCriteriaProductsRecapList({
  title,
  description,
  titleClassName,
  listClassName,
  skus,
}: ConfigurationCriteriaProductsRecapListProps): ReactElement {
  return (
    <div className='space-y-3'>
      <div className='flex flex-col gap-1'>
        <div className='flex items-center gap-2'>
          <h3 className={cn('font-medium', titleClassName)}>{title}</h3>
        </div>
        <div className='mb-1.5 font-light text-layout-foreground-secondary text-sm'>
          {description}
        </div>
      </div>
      <ScrollArea className='h-64 w-full rounded-md border px-3 dark:bg-card-lighter'>
        <div className='my-3 space-y-2'>
          {skus.map((sku, index) => (
            <div
              className={cn(
                'flex items-center justify-between rounded-md border p-2',
                listClassName,
              )}
              key={index}
            >
              <span className='font-mono text-sm'>{sku}</span>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
